module.exports = __webpack_public_path__ + "img/ROBUR.3b76f689.webp";